import React, { Component } from "react";
import TweenOne from "rc-tween-one";
import "./../../assets/styles/Preloader.css";
import pngLoader from '../../assets/images/anim_intro_minicov_text.gif';

class SimpleLoader extends Component {
  static defaultProps = {
    appState: null
  };

  state = {
    isAppInitialized: false
  };

  render() {
    const screenWidth = window.innerWidth;
    const stateAppLoaded =
      this.props.appState === "inicializing" ||
      this.props.appState === "loading"
        ? false
        : true;
    if (this.state.isAppInitialized) {
      return null;
    }
    return (
      <>
        <TweenOne
          className="preloader_animate"
          paused={!stateAppLoaded}
          animation={{
            y: -screenWidth,
            opacity: 0,
            onComplete: () =>
              this.setState({
                isAppInitialized: true
              })
          }}>
          <img src={pngLoader} alt="Animated logo" />
        </TweenOne>
      </>
    );
  }
}

export default SimpleLoader;
